export default __webpack_public_path__ + "static/1760-b3f87152342cfa939863146bf026287f.jpg";